import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";
import { intlLocale, type Locale } from "../i18n/locale";

// "2 days ago" / "hace 2 días". `locale` is the app's active UI locale; Spanish
// uses date-fns's `es` locale, everything else its built-in (English) default.
export const timeAgo = (dateString: string, locale?: Locale): string => {
  return formatDistanceToNow(new Date(dateString), {
    addSuffix: true,
    locale: locale === "es" ? es : undefined,
  });
};

// Localised absolute date, e.g. "3 Aug 2026" / "3 ago 2026". Used for the recipe
// "Added" / "Edited" lines, where an unambiguous date reads better than "ago".
export const formatDate = (dateString: string, locale?: Locale): string =>
  new Date(dateString).toLocaleDateString(intlLocale(locale ?? "en"), {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

// "Last cooked" recency label: relative for the past year ("3 days ago",
// "2 months ago"), then a short dd/mm/yy date beyond that — so an old cook reads
// as a real date instead of "over 2 years ago". Locale-aware for both forms.
export const formatLastCooked = (dateString: string, locale?: Locale): string => {
  const d = new Date(dateString);
  const withinYear = Date.now() - d.getTime() < 365 * 24 * 60 * 60 * 1000;
  if (withinYear) {
    return formatDistanceToNow(d, {
      addSuffix: true,
      locale: locale === "es" ? es : undefined,
    });
  }
  return d.toLocaleDateString(intlLocale(locale ?? "en"), {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};
